import type { Maybe, VariantType, VariantTypeV2 } from "@shared/graphql.types";

const addSlugInPDPUrl = () =>
  Boolean(process.env.NEXT_PUBLIC_USE_SLUG_IN_PDP_URL);
const isProduction = () => process.env.NODE_ENV === "production";

export const getPDPUrl = (
  variant: Maybe<VariantType>,
  locale: string,
  forTracking = false
): string => {
  const { pdpUrl, slug } = variant || {};

  // Favour the pdpUrl field if it exists and we're in an AWS environment
  if (
    isProduction() &&
    addSlugInPDPUrl() === false &&
    pdpUrl &&
    pdpUrl[locale.toLowerCase()]
  ) {
    const url = pdpUrl[locale.toLowerCase()] as string;
    // remove /us as next.js router adds locale.
    return !forTracking
      ? url.replace(/^https?:\/\/[^/]+/, "").replace(/^\/us\//, "/")
      : url.replace(/^https?:\/\/[^/]+/, "");
  }

  // This is a fallback for when the pdpUrl field is not populated applicable for CT elasticsearch store

  //BFF will return full path
  if (slug && slug.includes("/products")) {
    return slug;
  }

  if (slug) {
    return `/products/${slug}`;
  }

  return "/";
};

export const getPDPUrlV2 = (
  variant: Maybe<VariantTypeV2>,
  locale: string,
  forTracking = false
): string => {
  const { pdpUrl, slug } = variant || {};

  // Favour the pdpUrl field if it exists and we're in an AWS environment
  if (
    isProduction() &&
    addSlugInPDPUrl() === false &&
    pdpUrl &&
    pdpUrl[locale.toLowerCase()]
  ) {
    const url = pdpUrl[locale.toLowerCase()] as string;
    // remove /us as next.js router adds locale.
    return !forTracking
      ? url.replace(/^https?:\/\/[^/]+/, "").replace(/^\/us\//, "/")
      : url.replace(/^https?:\/\/[^/]+/, "");
  }

  // This is a fallback for when the pdpUrl field is not populated applicable for CT elasticsearch store
  if (slug) {
    return `/products/${slug}`;
  }

  return "/";
};
